import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

import { useHasUser } from 'utils/user';

type Props = RouteProps & {
  component: () => JSX.Element;
};

const PublicRoute = ({ component: Component, ...rest }: Props) => {
  const hasUser = useHasUser();
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        hasUser ? (
          <Redirect
            to={{
              pathname: '/home',
              state: { from: location.pathname },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
